import z from 'zod';

export const collectPaymentFormSchema = z.object({
  payment: z.object({
    amount: z.number(),
    currency: z.string(),
    isEditable: z.boolean().default(true),
  }),

  card: z.object({
    number: z.string(),
    exp: z.string(),
    cvv: z.string(),
  }),

  billing: z.object({
    firstName: z.string(),
    lastName: z.string(),
    address1: z.string(),
    zip: z.string(),
    email: z.string(),
  }),
});

export type CollectPaymentForm = z.infer<typeof collectPaymentFormSchema>;
